registerComponent("pages/privacy-policy", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * O acordeão das políticas: cada `blocks/title-box` abre e fecha o
 * `.wrappe-content` que vem depois dele. Em 2020 era
 * `$this.next().slideUp()`/`slideDown()`, que animava `height` medindo o
 * conteúdo a cada clique — `height: auto` não anima, então aqui é `max-height`
 * em transição, a receita de `pages/about`.
 *
 * ⚠️ Uma diferença em relação a `pages/about`, e ela importa: aqui o Blade abre
 * TODOS os blocos (`class="expanded"` em cada `title-box`), então o estado
 * inicial é o aberto e ele fica na tela o tempo inteiro. `max-height` fixo em
 * pixels cortaria o texto assim que a caixa reflui — fonte que troca, imagem
 * que carrega, janela que muda de largura, e as políticas têm tabela. Por isso
 * o aberto em repouso é `max-height` NENHUM: o valor em pixels só existe
 * durante a transição, e sai no `transitionend`.
 *
 * O `$document.trigger('scroll')` que o legado disparava 200ms depois do clique
 * SAI: ele existia para acordar quem escutava `scroll` no jQuery (o header e o
 * `Animator`) depois de a página mudar de altura. Hoje o header vive sobre
 * `Asa.aoRolar`, que lê a rolagem real, e as entradas são por
 * IntersectionObserver, que reavalia por conta própria quando a caixa muda.
 */

const cabecalhos = component.querySelectorAll('[data-component-name="blocks/title-box"]');

/**
 * Abre, fecha e o estado inicial de um par cabeçalho/painel. O temporizador da
 * rede de segurança fica no fecho de cada par — um por bloco, e nenhum deles no
 * DOM.
 *
 * @param {HTMLElement} cabecalho
 * @param {HTMLElement} painel
 * @returns {void}
 */
function ligarBloco(cabecalho, painel) {
    let temporizador = null;

    /**
     * Tira o `max-height` do painel aberto, para que ele volte a acompanhar o
     * conteúdo. Chamado no fim da abertura (ou na hora, sem movimento).
     *
     * @returns {void}
     */
    function soltar() {
        clearTimeout(temporizador);
        painel.removeEventListener('transitionend', aoTerminar);
        painel.style.removeProperty('max-height');
    }

    /**
     * @param {TransitionEvent} evento
     * @returns {void}
     */
    function aoTerminar(evento) {
        if (evento.target === painel && evento.propertyName === 'max-height') {
            soltar();
        }
    }

    /** @returns {void} */
    function abrir() {
        painel.style.maxHeight = `${painel.scrollHeight}px`;

        if (!Asa.movimentoPermitido()) {
            soltar();

            return;
        }

        painel.addEventListener('transitionend', aoTerminar);

        // Rede de segurança: em aba de segundo plano o `transitionend` não vem.
        temporizador = setTimeout(soltar, Asa.ESPERA_MAXIMA);
    }

    /** @returns {void} */
    function fechar() {
        clearTimeout(temporizador);
        painel.removeEventListener('transitionend', aoTerminar);

        // Sair de `none` direto para `0` não anima: o quadro de partida precisa
        // de um valor em pixels, e o `offsetHeight` força a pintura dele.
        painel.style.maxHeight = `${painel.scrollHeight}px`;
        void painel.offsetHeight;
        painel.style.maxHeight = '0px';
    }

    /*
     | `overflow` e `transition` entram aqui, no JS, e não no LESS, para que sem
     | JS o conteúdo continue inteiro e visível (regra do programa) — em 2020
     | quem escondia era o `slideUp`, também JS.
     */
    painel.style.overflow = 'hidden';
    painel.style.transition = 'max-height .3s ease';

    if (!cabecalho.classList.contains('expanded')) {
        painel.style.maxHeight = '0px';
    }

    cabecalho.addEventListener('click', function () {
        const aberto = cabecalho.classList.contains('expanded');

        // Tagueamento (plano v3.1): a política aberta ou fechada, pelo id da âncora.
        const secao = cabecalho.closest('[id]');

        Asa.track('section_nav_click', { nav_area: 'policy_accordion', target_id: secao ? secao.id : undefined, method: aberto ? 'close' : 'open' });

        cabecalho.classList.toggle('expanded', !aberto);
        cabecalho.classList.toggle('retracted', aberto);

        if (aberto) {
            fechar();
        } else {
            abrir();
        }
    });
}

cabecalhos.forEach(function (cabecalho) {
    const painel = cabecalho.nextElementSibling;

    if (painel && painel.classList.contains('wrappe-content')) {
        ligarBloco(cabecalho, painel);
    }
});

});
